import * as React from 'react';
import { Box, useTheme } from '@mui/material';
import {
    selectedPrescripteursSelector,
    useTiersServiceSelector,
} from '@europrocurement/l2d-domain';
import { AssistanceCardHeader } from './AssistanceCardHeader';
import { AssistanceCardMenu, AssistanceCardView } from './AssistanceCardMenu';
import { useAssistanceContacts } from './useAssistanceContacts';
import { UserContactCardProps } from '../UserContactCard';

export type AssistanceCardProps = {
    onClose: () => void;
    onContactRequest?: (props: UserContactCardProps) => void;
};

export const AssistanceCard: React.FunctionComponent<AssistanceCardProps> = function ({
    onClose,
    onContactRequest,
}) {
    const prescripteur = useTiersServiceSelector(selectedPrescripteursSelector);
    const { formalisteUserData, commercialUserData, isLoadingContacts } =
        useAssistanceContacts(prescripteur);
    const theme = useTheme();

    const handleSelectContact = (selectedView: AssistanceCardView) => {
        if (!onContactRequest) return;

        const isFormaliste = selectedView === 'formaliste';
        const userData = isFormaliste ? formalisteUserData : commercialUserData;
        onContactRequest({
            label: 'Être recontacté',
            source: 'FRONT',
            userId: isFormaliste
                ? prescripteur?.formaliste?.id || 0
                : prescripteur?.idPrescripteur || 0,
            userType: isFormaliste ? 'UTILISATEUR' : 'COMMERCIAL',
            displayUserSchedule: true,
            displayActionContact: true,
            initialUserData: userData ?? undefined,
            errorHeaderText: 'Informations Indisponibles',
        });
        onClose();
    };

    return (
        <Box
            data-assistance-card="true"
            sx={{
                minWidth: '400px',
                width: 'fit-content',
                backgroundColor: theme.palette.background.paper,
                borderRadius: '12px',
                boxShadow: 5,
                padding: '24px',
            }}
        >
            <AssistanceCardHeader onClose={onClose} />
            <AssistanceCardMenu
                formalisteUserData={formalisteUserData}
                commercialUserData={commercialUserData}
                isLoadingContacts={isLoadingContacts}
                onSelectContact={handleSelectContact}
            />
        </Box>
    );
};

export default AssistanceCard;
